<div class="modal-header">
  <h5 class="modal-title">Session Timeout Warning</h5>
</div>
<div class="modal-body">
  <p> Your session will expire in {{ remainingSeconds$ | async }} seconds.</p>
  <p> Click on <b>Continue</b> to continue your session. </p>
  <div class="session-ctn-btn"> <button type="button" class="next-btn" (click)="continueSession()">Continue</button>
  </div>
</div>